import React, { useEffect, useState, useCallback } from 'react'

const STATUS_META = {
  ok:             { bg:'rgba(16,185,129,0.12)', color:'#34d399', icon:'✅', label:'Working' },
  error:          { bg:'rgba(239,68,68,0.12)',  color:'#f87171', icon:'❌', label:'Broken' },
  not_configured: { bg:'rgba(var(--fg-rgb),0.06)', color:'rgba(var(--fg-rgb),var(--a40))', icon:'⚪', label:'Not Set Up' },
}

function timeAgo(iso) {
  if (!iso) return ''
  const m = Math.floor((Date.now() - new Date(iso).getTime()) / 60000)
  if (m < 1) return 'just now'
  if (m < 60) return `${m}m ago`
  return `${Math.floor(m/60)}h ago`
}

export default function SystemHealth() {
  const [data,    setData]    = useState(null)
  const [loading, setLoading] = useState(true)
  const [err,     setErr]     = useState('')

  const load = useCallback(async () => {
    setLoading(true); setErr('')
    try {
      const res = await fetch('/api/health-check')
      const json = await res.json()
      setData(json)
    } catch (e) {
      setErr(e.message)
    }
    setLoading(false)
  }, [])

  useEffect(() => { load() }, [load])

  const services = data?.services || []
  const brokenCount = services.filter(s => s.status === 'error').length

  return (
    <div style={{ marginTop:'14px' }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'16px', flexWrap:'wrap', gap:'10px' }}>
        <div>
          <div style={{ fontSize:'16px', fontWeight:700, color:'rgba(var(--fg-rgb),var(--a85))' }}>🩺 System Health</div>
          <div style={{ fontSize:'12px', color:'rgba(var(--fg-rgb),var(--a30))', marginTop:'2px' }}>
            {data ? `Last checked ${timeAgo(data.checkedAt)}` : 'Checking...'}
          </div>
        </div>
        <button onClick={load} disabled={loading} style={{ fontSize:'12px', padding:'7px 14px', borderRadius:'9px', background:'rgba(var(--fg-rgb),0.06)', color:'rgba(var(--fg-rgb),var(--a50))', border:'none', cursor:'pointer', fontFamily:'inherit', opacity: loading ? 0.6 : 1 }}>
          {loading ? 'Checking...' : '↻ Recheck Now'}
        </button>
      </div>

      {err && <div style={{ padding:'10px 14px', background:'rgba(239,68,68,0.1)', color:'#f87171', borderRadius:'9px', fontSize:'13px', marginBottom:'14px' }}>⚠ Couldn't run health check: {err}</div>}

      {!loading && brokenCount > 0 && (
        <div style={{ display:'flex', alignItems:'center', gap:'10px', padding:'12px 16px', background:'rgba(239,68,68,0.08)', border:'1px solid rgba(239,68,68,0.25)', borderRadius:'12px', marginBottom:'16px' }}>
          <span style={{ fontSize:'20px' }}>🚨</span>
          <div style={{ fontSize:'13px', fontWeight:700, color:'#f87171' }}>
            {brokenCount} service{brokenCount!==1?'s':''} {brokenCount!==1?'are':'is'} broken — see below for details.
          </div>
        </div>
      )}

      {!loading && brokenCount === 0 && services.length > 0 && (
        <div style={{ display:'flex', alignItems:'center', gap:'10px', padding:'12px 16px', background:'rgba(16,185,129,0.08)', border:'1px solid rgba(16,185,129,0.25)', borderRadius:'12px', marginBottom:'16px' }}>
          <span style={{ fontSize:'20px' }}>✅</span>
          <div style={{ fontSize:'13px', fontWeight:700, color:'#34d399' }}>Everything that's set up is working fine.</div>
        </div>
      )}

      <div style={{ display:'grid', gap:'8px' }}>
        {services.map(s => {
          const meta = STATUS_META[s.status] || STATUS_META.not_configured
          return (
            <div key={s.name} style={{ display:'flex', alignItems:'center', gap:'12px', padding:'13px 16px', background:'rgba(var(--fg-rgb),0.03)', border:`0.5px solid ${s.status==='error' ? 'rgba(239,68,68,0.25)' : 'rgba(var(--fg-rgb),0.07)'}`, borderRadius:'12px' }}>
              <span style={{ fontSize:'18px' }}>{meta.icon}</span>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontSize:'13px', fontWeight:700, color:'rgba(var(--fg-rgb),var(--a85))' }}>{s.name}</div>
                <div style={{ fontSize:'11px', color:'rgba(var(--fg-rgb),var(--a35))', marginTop:'2px' }}>{s.message}</div>
              </div>
              <span style={{ fontSize:'10px', fontWeight:700, padding:'4px 10px', borderRadius:'20px', background:meta.bg, color:meta.color, whiteSpace:'nowrap' }}>{meta.label}</span>
            </div>
          )
        })}
      </div>

      {loading && !data && (
        <div style={{ textAlign:'center', padding:'3rem', color:'rgba(var(--fg-rgb),var(--a20))', fontSize:'13px' }}>Running checks...</div>
      )}
    </div>
  )
}
